export const pushDataLayer = (initObj) => {
  if (window.dataLayer) {
    window.dataLayer.push(initObj);
  } 
}
